import React, { FC } from 'react'
import { Typography, Card, useMediaQuery, useTheme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import LinkVariant from 'src/Elements/Buttons/LinkVariant'
import { RetrofitPartnerContact } from '../../models'

const useStyles = makeStyles()(theme => ({
  companyCard: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    gap: theme.spacing(1),
    width: 'fit-content',
    boxShadow: 'none',
    borderColor: theme.palette.grey.grey06,
    h3: {
      fontWeight: 400,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  companyCardLink: {
    color: theme.palette.primary.main,
    fontSize: 16,
  },
}))

interface CompanyCardProps {
  data: RetrofitPartnerContact
}

/**
 * Company card for attached companies in the installer contact component
 */
const CompanyCard: FC<CompanyCardProps> = ({ data }) => {
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const { classes } = useStyles()
  const phone = data.telephone
  const email = data.email

  return (
    <Card className={classes.companyCard} variant="outlined">
      <Typography variant="h3">{data.name}</Typography>
      {phone &&
        (downMd ? (
          <LinkVariant type="phone" link={phone} label={phone} linkClassName={classes.companyCardLink} hasUnderline={false} />
        ) : (
          <Typography variant="body2">{phone}</Typography>
        ))}
      {email && <LinkVariant type="email" link={email} label={email} linkClassName={classes.companyCardLink} hasUnderline={false} />}
    </Card>
  )
}

export default CompanyCard
